import { render, staticRenderFns } from "./FormContact.vue?vue&type=template&id=a3be371c&scoped=true&"
import script from "./FormContact.vue?vue&type=script&lang=js&"
export * from "./FormContact.vue?vue&type=script&lang=js&"
import style0 from "./FormContact.vue?vue&type=style&index=0&id=a3be371c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3be371c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-web/node_modules/@vue/cli-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3be371c')) {
      api.createRecord('a3be371c', component.options)
    } else {
      api.reload('a3be371c', component.options)
    }
    module.hot.accept("./FormContact.vue?vue&type=template&id=a3be371c&scoped=true&", function () {
      api.rerender('a3be371c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/FormContact.vue"
export default component.exports